import React, { useEffect, useState } from "react";
import "./expertise.scss";
import { OurExpertise } from "../../../constants/Home";

const Expertise = () => {
  return (
    <>
      <section id="our-expertise-wrapper">
        <div className="expertise-wrapper">
          <h2 className="heading">
            Our <span>Expertise</span>
          </h2>
          <div className="expertise">
            {OurExpertise?.map((item, index) => {
              return (
                <>
                  {index <= 3 && (
                    <div className="expertise-image tab-hidden">
                      <img src={item?.image} alt="" />
                      <p>{item.title}</p>
                    </div>
                  )}   
                    <div className="expertise-image hide-show">
                      <img src={item?.image} alt="" />
                      <p>{item.title}</p>
                    </div>
                </>
              );
            })}
          </div>
          <div className="background-area right tab-hidden">
            <hr />
            <hr />
            <hr />
          </div>
        </div>
      </section>
      <section id="our-expertise-wrapper">
        <div className="expertise-wrapper pt-0 tab-hidden">
          <div className="expertise-left">
            {OurExpertise?.map((item, index) => {
              return (
                <>
                  {index > 3 && (
                    <div className="expertise-image">
                      <img src={item?.image} alt="" />
                      <p>{item.title}</p>
                    </div>
                  )}
                </>
              );
            })}
          </div>
          <div className="background-area left">
            <hr />
            <hr />
            <hr />
          </div>
        </div>
      </section>
    </>
  );
};

export default Expertise;
